export interface ButtonConfig {
  id: string;
  label: string;
  to: string;
  variant: 'primary' | 'secondary';
  requiredAuth?: boolean;
  requiredRole?: string;
  hideWhenAuthenticated?: boolean;
}

export const homePageButtons: ButtonConfig[] = [
  {
    id: 'map',
    label: 'Vedi Mappa',
    to: '/map',
    variant: 'primary'
  },
  {
    id: 'admin-dashboard',
    label: 'Dashboard Admin',
    to: '/admin/dashboard',
    variant: 'secondary',
    requiredAuth: true,
    requiredRole: 'admin'
  },
  {
    id: 'new-report',
    label: 'Nuova Segnalazione',
    to: '/report',
    variant: 'secondary',
    requiredAuth: true,
  },
  {
    id: 'login',
    label: 'Accedi',
    to: '/login',
    variant: 'secondary',
    hideWhenAuthenticated: true
  }
];